<div class="notificationReminder">
  <span class="notificationReminder__content">
    <span
      class="notificationReminder__blue"
      [class.notificationReminder__red]="appliedDeletedStyle"
    >
      <div class="notification__image-wrapper--svg">
        <pp-icon
          [ppSrc]="EIconPath.ICON_MISC_REMINDER_ICON_14"
          ppClass="setSize14"
          ppColor="inherit"
        ></pp-icon>
      </div>

      <span>{{ notificationTextBlue }}</span>
    </span>

    {{ notificationText }}
  </span>
  <span class="notification__reminderName">{{ ppNotification().refObject.name }}</span>
</div>
